import React from 'react';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const teamData = [
  {
    name: 'Alice Smith',
    role: 'Project Manager',
    completedTasks: 5,
    ongoingTasks: [
      { title: 'Coordinate with the marketing team', status: 'In Progress' },
      { title: 'Finalize project timeline', status: 'Not Started' },
    ],
  },
  {
    name: 'Bob Johnson',
    role: 'Developer',
    completedTasks: 8,
    ongoingTasks: [
      { title: 'Implement user authentication', status: 'In Progress' },
      { title: 'Develop API endpoints', status: 'In Progress' },
    ],
  },
  {
    name: 'Cathy Brown',
    role: 'Designer',
    completedTasks: 4,
    ongoingTasks: [
      { title: 'Create wireframes for the new feature', status: 'In Progress' },
    ],
  },
];

const TeamPage = () => {
  return (
    <div className="p-6 bg-gray-900 text-white min-h-screen">
      <SEO
        title="Marketing Team"
        description="Manage your film's marketing team and assign promotional tasks on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/marketing-team"
        robots="noindex, nofollow"
      />
      <h1 className="text-4xl font-bold mb-6" style={{fontSize:'24px'}}>Team Page</h1>
      <table className="min-w-full bg-gray-800 border border-gray-700">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b border-gray-700 text-left">Name</th>
            <th className="py-2 px-4 border-b border-gray-700 text-left">Role</th>
            <th className="py-2 px-4 border-b border-gray-700 text-left">Completed Tasks</th>
            <th className="py-2 px-4 border-b border-gray-700 text-left">Ongoing Tasks</th>
          </tr>
        </thead>
        <tbody>
          {teamData.map((member, index) => (
            <tr key={index} className="hover:bg-gray-700">
              <td className="py-2 px-4 border-b border-gray-700">{member.name}</td>
              <td className="py-2 px-4 border-b border-gray-700">{member.role}</td>
              <td className="py-2 px-4 border-b border-gray-700">{member.completedTasks}</td>
              <td className="py-2 px-4 border-b border-gray-700">
                <ul className="list-disc list-inside">
                  {member.ongoingTasks.map((task, taskIndex) => (
                    <li key={taskIndex} className="mt-1">
                      <span className="font-bold">{task.title}</span> - <span className={`text-${task.status === 'In Progress' ? 'yellow-400' : 'red-400'}`}>{task.status}</span>
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TeamPage;

